import {
  GET_EXCO_PUSAT,
  GET_EXCO_PUSAT_SUCCESS,
  GET_EXCO_PUSAT_FAIL,
  GET_DETAIL_EXCO_PUSAT,
  GET_DETAIL_EXCO_PUSAT_SUCCESS,
  GET_DETAIL_EXCO_PUSAT_FAIL,
  PATCH_EXCO_PUSAT,
  PATCH_EXCO_PUSAT_SUCCESS,
  PATCH_EXCO_PUSAT_FAIL,
  GET_EXCO_RTRW,
  GET_EXCO_RTRW_SUCCESS,
  GET_EXCO_RTRW_FAIL,
  GET_EXCO_PUK,
  GET_EXCO_PUK_SUCCESS,
  GET_EXCO_PUK_FAIL,
  CREATE_EXCO_RTRW,
  CREATE_EXCO_RTRW_SUCCESS,
  CREATE_EXCO_RTRW_FAIL,
} from "./actionTypes";

const initialState = {
  dataExcoPusat: {
    loading: false,
    error: false,
    data: null,
  },
  dataDetailExcoPusat: {
    loading: false,
    error: false,
    data: null,
  },
  patchExoPusat: {
    loading: false,
    error: false,
    data: null,
  },
  dataExcoRTRW: {
    loading: false,
    error: false,
    data: null,
  },
  dataExcoPUK: {
    loading: false,
    error: false,
    data: null,
  },
  createExcoRTRW: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // get table exco pusat
    case GET_EXCO_PUSAT:
      return {
        ...state,
        dataExcoPusat: {
          ...state.dataExcoPusat,
          loading: true,
          error: false,
        },
      };
    case GET_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        dataExcoPusat: {
          ...state.dataExcoPusat,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_EXCO_PUSAT_FAIL:
      return {
        ...state,
        dataExcoPusat: {
          ...state.dataExcoPusat,
          loading: false,
          error: action.payload,
        },
      };
    // get detail exco
    case GET_DETAIL_EXCO_PUSAT:
      return {
        ...state,
        dataDetailExcoPusat: {
          ...state.dataDetailExcoPusat,
          loading: true,
          error: false,
        },
      };
    case GET_DETAIL_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        dataDetailExcoPusat: {
          ...state.dataDetailExcoPusat,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_DETAIL_EXCO_PUSAT_FAIL:
      return {
        ...state,
        dataDetailExcoPusat: {
          ...state.dataDetailExcoPusat,
          loading: false,
          error: action.payload,
        },
      };
    // patch exco pusat
    case PATCH_EXCO_PUSAT:
      return {
        ...state,
        patchExoPusat: {
          ...state.patchExoPusat,
          loading: true,
          error: false,
        },
      };
    case PATCH_EXCO_PUSAT_SUCCESS:
      return {
        ...state,
        patchExoPusat: {
          ...state.patchExoPusat,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case PATCH_EXCO_PUSAT_FAIL:
      return {
        ...state,
        patchExoPusat: {
          ...state.patchExoPusat,
          loading: false,
          error: action.payload,
        },
      };

    // get exco rt rw
    case GET_EXCO_RTRW:
      return {
        ...state,
        dataExcoRTRW: {
          ...state.dataExcoRTRW,
          loading: true,
          error: false,
        },
      };
    case GET_EXCO_RTRW_SUCCESS:
      return {
        ...state,
        dataExcoRTRW: {
          ...state.dataExcoRTRW,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_EXCO_RTRW_FAIL:
      return {
        ...state,
        dataExcoRTRW: {
          ...state.dataExcoRTRW,
          loading: false,
          error: action.payload,
        },
      };

    // get exco puk
    case GET_EXCO_PUK:
      return {
        ...state,
        dataExcoPUK: {
          ...state.dataExcoPUK,
          loading: true,
          error: false,
        },
      };
    case GET_EXCO_PUK_SUCCESS:
      return {
        ...state,
        dataExcoPUK: {
          ...state.dataExcoPUK,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case GET_EXCO_PUK_FAIL:
      return {
        ...state,
        dataExcoPUK: {
          ...state.dataExcoPUK,
          loading: false,
          error: action.payload,
        },
      };

    // create exco rt rw
    case CREATE_EXCO_RTRW:
      return {
        ...state,
        createExcoRTRW: {
          ...state.createExcoRTRW,
          loading: true,
          error: false,
        },
      };
    case CREATE_EXCO_RTRW_SUCCESS:
      return {
        ...state,
        createExcoRTRW: {
          ...state.createExcoRTRW,
          loading: false,
          error: false,
          data: action.payload,
        },
      };
    case CREATE_EXCO_RTRW_FAIL:
      return {
        ...state,
        createExcoRTRW: {
          ...state.createExcoRTRW,
          loading: false,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
